import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiConfigCached } from '../config/api.config';

// Get the API configuration
const apiConfig = getApiConfigCached();

// For development, ensure we use localhost explicitly
const baseUrl = apiConfig.apiUrl;

console.log('[RTK Query API] Configuration:', {
  envApiUrl: import.meta.env.VITE_API_URL,
  configApiUrl: apiConfig.apiUrl,
  finalBaseUrl: import.meta.env.VITE_API_URL || baseUrl,
});

// Base API setup for RTK Query
export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_URL || baseUrl,
  }),
  endpoints: () => ({}),
});

export default api;
